module.exports = __webpack_public_path__ + "static/media/mapSubwayMore.b1de2618.png";